import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { InstacitiLandingComponent } from "./instaciti-landing/instaciti-landing.component";
import { SharedModule } from "src/app/shared.module";
import { InstaCitiNewRoutingModule } from "./instaciti-new.routing";
import { InstacitiHeaderComponent } from "./instaciti-header/instaciti-header.component";
import { InstacitiNewService } from "./service/instaciti-new.service";
import { InstacitiSearchComponent } from "./instaciti-search/instaciti-search.component";
import { InstacitiQuickCategoriesComponent } from "./instaciti-quick-categories/instaciti-quick-categories.component";
import { InstacitiPromotedCategoriesComponent } from "./instaciti-promoted-categories/instaciti-promoted-categories.component";
import { InstacitiPopularCategoriesComponent } from "./instaciti-popular-categories/instaciti-popular-categories.component";
import { InstacitiOtherCategoriesComponent } from "./instaciti-other-categories/instaciti-other-categories.component";
import { RestaurantListingComponent } from './restaurant-listing/restaurant-listing.component';
import { InstacitiFooterComponent } from './instaciti-footer/instaciti-footer.component';
import { InstacitiSupportComponent } from './instaciti-support/instaciti-support.component';
import { BeautyAndSpaComponent } from './beauty-and-spa/beauty-and-spa.component';
import { InstacitiBannerComponent } from './instaciti-banner/instaciti-banner.component';
import { InstacitiListingComponent } from './instaciti-listing/instaciti-listing.component';
import { SchoolDetailsComponent } from './school-details/school-details.component';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { FormsModule } from '@angular/forms';
import { AutomobileDetailsComponent } from './automobile-details/automobile-details.component';
import { AutomobileModule } from "src/app/bizspots/automobile/automobile.module";
import { RealEstateDetailsComponent } from './real-estate-details/real-estate-details.component';
import { RealEstateModule } from "src/app/bizspots/real-estate/real-estate.module";
import { RealEstateListingDetailsComponent } from './real-estate-listing-details/real-estate-listing-details.component';

@NgModule({
  declarations: [
    InstacitiLandingComponent,
    InstacitiHeaderComponent,
    InstacitiSearchComponent,
    InstacitiQuickCategoriesComponent,
    InstacitiPromotedCategoriesComponent,
    InstacitiPopularCategoriesComponent,
    InstacitiOtherCategoriesComponent,
    RestaurantListingComponent,
    InstacitiFooterComponent,
    InstacitiSupportComponent,
    BeautyAndSpaComponent,
    InstacitiBannerComponent,
    InstacitiListingComponent,
    SchoolDetailsComponent,
    AutomobileDetailsComponent,
    RealEstateDetailsComponent,
    RealEstateListingDetailsComponent,
  ],
  imports: [CommonModule, FormsModule, SharedModule, InstaCitiNewRoutingModule, MatAutocompleteModule,AutomobileModule,RealEstateModule],
  providers: [InstacitiNewService],
})
export class InstacitiNewModule {}
